<style  scoped>

.section__sectors__FixedHeight900
{
    height: 900px;
}

.u-bg--white__Sectors__ValueAdded
{
    background-color: #00315c;
}

.u-bg--white__Sectors__Cybersecurity
{
    background-color: #e7e8e9;
}

</style>

<template>

<div class="c-page u-relative">
<section    data-color="clear" class="u-relative u-fit-w u-bg--brand-dark u-pad-x-w1of12  u-pad-x-w1of12@s u-overflow-h js-header-panel">
      <!--<div class="c-page__header o-wrapper--panel" :style="myStylesTransform2">
        <video-player :VideoSize="myStylesWidthHeight"></video-player>
      </div>-->
       <div class="c-page__header o-wrapper--panel" :style="'transform:translateX(' + headerPageSize[2] + 'px) translateY('+headerPageSize[3]+'px) scale('+headerPageSize[4]+')'" >
             <img :src="globalContent.nav.links[0].image.src" class="u-absolute u-pos-tl" :style="'width:' + headerPageSize[0] + 'px; height:'+headerPageSize[1]+'px' ">
             
       </div>
       
      <div class="c-puzzle o-wrapper--panel u-fit u-overflow-h">
              <div class="c-puzzle__piece u-absolute" style="background-color: rgb(51,51,51); opacity: 0.4;"></div>
              <div class="c-puzzle__piece u-absolute" style="background-color: rgb(51, 51, 51); opacity: 0.2;"></div>
              <div class="c-puzzle__piece u-absolute" style="background-color: rgb(51, 51, 51); opacity: 0.2;"></div>
              <div class="c-puzzle__piece u-absolute" style="background-color: rgb(51, 51, 51); opacity: 0.29;"></div>
              <div class="c-puzzle__piece u-absolute" style="background-color: rgb(51, 51, 51); opacity: 0.29;"></div>
      </div>
      <div class="o-wrapper--valign u-viewport-fit-h u-fit-w u-zindex--2">
          <div class="u-relative u-inline-block u-valign-bottom u-marg-l-w1of12 u-marg-b-vh1of12 u-marg-b-vh3of12@sm" >
             <h1 class="t-h3Privinvest  t-text-lh--sm  u-color--white u-marg-b-vh1of12" style="border solid 1px #fff">

               <app-sliced-text :content="content.title"></app-sliced-text>
             </h1>
              <div class="sellbuy">

              <div class="sellbuy-container">
                <div>
                    <a class="sellbuy-button sellbuy-button-BUY" href="/static/home/ISO-2000-Salameh-Traiteur-Gourmet.pdf"  target="_blanc">
                      <ul>
                        <li>&nbsp;</li>
                        <li>ISO</li>
                        <li>22000</li>
                      </ul>


                    </a>
                </div>
              <!--<div>
              <a class="sellbuy-button sellbuy-button-SELL"  href="/static/home/salameh-special-offer.pdf"  target="_blanc">
                <ul>
                  <li>Special</li>
                  <li>Offers</li>
                  <li>Check</li>
                </ul>
              </a>
              </div>
              <div class="sellbuy-button-hide">
              <a class="sellbuy-button sellbuy-button-TradeIN"  href="/static/home/salameh-chicken-Gourmet.pdf"  target="_blanc">
                <ul>
                  <li>Menu</li>
                  <li>Christmas</li>
                  <li>download</li>
                </ul>
              </a>
            </div>
            -->
              </div>
            </div>
          </div>   
            <button v-scroll-to="'#start'" class="c-home__scroll-btn c-btn-scroll  u-pos-x-center t-btn u-absolute u-inline-block  u-marg-b-md@sm">
           <img src="/static/common/MainLogoWhite -arrow-white2.svg"  width="32px" >
    </button>

      </div>

      

   
  </section>
    <section :data-color="item.dataColor"   v-for="(item, index)  in content.blocks"  class=" futurestart u-relative u-overflow-h u-fit-w  u-pad-x-w1of12  u-pad-x-w1of12@sm   js-header-panel" :class="[item.bgColorClass]" :style="item.height">
      <a id="start">
      <div  class="u-absolute u-pos-bl" v-if="index===0">
        <img src="/static/home/Ship1.jpg" class="u-fit-futurestart u-disp-block">
        <img src="/static/home/Ship1-350.jpg" class="u-fit-futurestart80 u-disp-block">
        <img src="/static/home/Ship1-330.jpg" class="u-fit-futurestart70 u-disp-block">
        <img src="/static/home/Ship1-270.jpg" class="u-fit-futurestart60 u-disp-block">
        <img src="/static/home/Ship1-1018.jpg" class="u-fit-futurestart1024 u-disp-block">
      </div>
      </a>
      <!--<div v-if="index===1" class="c-page__header o-wrapper--panel " :style="myStylesTransform2">
              <img src="/static/home/BackgroundInfo.jpg" class="u-absolute u-pos-tl u-fit u-object-fit-cover" :style="myStylesWidthHeight">
      </div>-->
      <div  class="u-absolute u-pos-br u-align-right" v-if="index===3">
        <img src="/static/home/ShipInside.jpg" class="u-fit-futurestart u-disp-block">
        <img src="/static/home/ShipInside-350.jpg" class="u-fit-futurestart80 u-disp-block">
        <img src="/static/home/ShipInside-330.jpg" class="u-fit-futurestart70 u-disp-block">
        <img src="/static/home/ShipInside-270.jpg" class="u-fit-futurestart60 u-disp-block">
        <img src="/static/home/ShipInside-1018.jpg" class="u-fit-futurestart1024 u-disp-block">
      </div>
        <div   class="c-investors__section u-relative u-flex u-pad-yb0-lg@sm u-flex-fd--column@md u-pad-y-md-futurestart u-zindex--2" v-if="item.special==='special-right'">
          <div class=" u-marg-b-lg@sm u-w1of2   u-pad-l-0@lg u-fit-w@lg" :class="{'u-pad-l-w1of8':item.padLeft==='1'}">
          </div>
             <div class="u-marg-b-lg@sm u-w1of2   u-pad-l-0@lg u-fit-w@lg" :class="{'u-pad-l-w1of8':item.padLeft==='1'}">
                <div>
                    <app-scroll-object :offset=".05" :isParallax="!1" inline-template :content="item">
                      <div class="w2of10 u-w1of3@md u-fit-w@lg">
                        <h1 class="t-h1 t-text--roman u-relative u-marg-r-0@sm u-color--gray"  :class="{'u-color--brand-dark':content.color==='dark','u-color--white':content.color==='white'}">
                            
                            <app-words  :isActive="isActive" :delay="10" :content="content.title"></app-words>
                          </h1>
                      </div>
                    </app-scroll-object>
                </div>
                <div :key="indexin" v-for="(itemin, indexin)  in item.content">
                    <h6 class="t-text--xl t-text-lh--md t-text--ultra u-pad-t-lg" v-if="'title'===itemin.type.value" :class="[{'t-text--ultra--bold':itemin.bold==='true','u-color--brand-dark':itemin.color==='dark','u-color--white':itemin.color==='white','u-color--gray':itemin.color==='gray'},itemin.textalign]">
                        <app-scroll-object   :offset=".05"  :isParallax="!1" inline-template  :content="itemin" >
                             <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                         </app-scroll-object >
                      </h6>
                    <div class="u-marg-t-md t-text--ultra" v-if=" 'default'===itemin.type.value" :class="[{'u-marg-t-md':indexin>0,'u-color--lightblue':itemin.color==='dark','u-color--white':itemin.color==='white'},itemin.textalign]" v-html="itemin.content"> </div>
                </div>
            </div>
          </div>

          <div   class="c-investors__section u-relative u-flex u-pad-yb0-lg@sm u-flex-fd--column@md u-pad-y-md-futurestart u-zindex--2" v-if="item.special==='special-all-left'">
              <div class="u-marg-b-lg@sm u-w2of2   u-pad-l-0@lg u-fit-w@lg" :class="{'u-pad-l-w1of8':item.padLeft==='1'}">
                  <div>
                      <app-scroll-object :offset=".05" :isParallax="!1" inline-template :content="item">
                        <div class="w2of10 u-w1of3@md u-fit-w@lg">
                          <h1 class="t-h1 t-text--roman u-relative u-marg-r-0@sm"  :class="{'u-color--brand-dark':content.color==='dark','u-color--white':content.color==='white'}">
                              
                              <app-words  :isActive="isActive" :delay="4" :content="content.title"></app-words>
                            </h1>
                        </div>
                      </app-scroll-object>
                  </div>
                  <div :key="indexin" v-for="(itemin, indexin)  in item.content">
                      <h6 class="t-text--ultra t-text-lh--md t-text--ultra u-pad-t-lg" v-if="'title'===itemin.type.value" :class="{'t-text--ultra--bold':itemin.bold==='true','u-color--brand-dark':itemin.color==='dark','u-color--white':itemin.color==='white','u-color--gray':itemin.color==='gray'}">
                          <app-scroll-object   :offset=".05"  :isParallax="!1" inline-template  :content="itemin" >
                               <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                           </app-scroll-object >
                        </h6>
                      <div class="u-marg-t-md t-text--ultra" v-if=" 'default'===itemin.type.value" :class="[{'u-marg-t-md':indexin>0,'u-color--lightblue':itemin.color==='dark','u-color--white':itemin.color==='white'},itemin.textalign]" v-html="itemin.content"> </div>
                  </div>
              </div>
            </div>

          

              <div   class="c-investors__section u-relative u-flex u-pad-yb0-lg@sm u-flex-fd--column@md u-pad-y-md-futurestart u-zindex--2" v-if="item.special==='special-all-right'">
                 <div class="u-marg-b-lg@sm u-w2of2   u-pad-l-0@lg u-fit-w@lg" :class="{'u-pad-l-w1of8':item.padLeft==='1'}">
                     <div>
                         <app-scroll-object :offset=".05" :isParallax="!1" inline-template :content="item">
                           <div class="w2of10 u-w1of3@md u-fit-w@lg">
                             <h1 class="t-h1 t-text--roman u-relative u-marg-r-0@sm" style="text-align:right;" :class="{'u-color--brand-dark':content.color==='dark','u-color--white':content.color==='white'}">
                                 <span class="c-number-offset__QflyAllreverse u-hide@xs t-text--xl--Bold  u-absolute u-pos-bl" ></span>
                                 <app-words  :isActive="isActive" :delay="0" :content="content.title"></app-words>
                               </h1>
                           </div>
                         </app-scroll-object>
                     </div>
                     <div :key="indexin" v-for="(itemin, indexin)  in item.content">
                         <h6 class="t-text--ultra t-text-lh--md t-text--ultra u-pad-t-lg" v-if="'title'===itemin.type.value" :class="{'t-text--ultra--bold':itemin.bold==='true','u-color--brand-dark':itemin.color==='dark','u-color--white':itemin.color==='white','u-color--gray':itemin.color==='gray'}">
                             <app-scroll-object   :offset=".05"  :isParallax="!1" inline-template  :content="itemin" >
                                  <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                              </app-scroll-object >
                           </h6>
                         <div class="u-marg-t-md t-text--ultra" v-if=" 'default'===itemin.type.value" :class="[{'u-marg-t-md':indexin>0,'u-color--lightblue':itemin.color==='dark','u-color--white':itemin.color==='white'},itemin.textalign]" v-html="itemin.content"> </div>
                     </div>
                 </div>
               </div>

               <div   class="c-investors__section u-relative u-flex u-pad-yb0-lg@sm u-flex-fd--column@md u-pad-y-md-futurestart u-zindex--2" v-if="item.special==='special-left'">

                    <div class="u-marg-b-lg@sm u-w1of2 u-w1of2@md  u-pad-l-0@lg u-fit-w@lg" :class="{'u-pad-l-w1of8':item.padLeft==='1'}">
                       <div>
                           <app-scroll-object :offset=".05" :isParallax="!1" inline-template :content="item">
                             <div class="w2of10 u-w1of3@md u-fit-w@lg">
                               <h1 class="t-h1 t-text--roman u-relative u-marg-r-0@sm "  :class="{'u-color--brand-dark':content.color==='dark','u-color--white':content.color==='white'}">
                                  <app-words  :isActive="isActive" :delay="0" :content="content.title"></app-words>
                                 </h1>
                             </div>
                           </app-scroll-object>
                       </div>
                       <div :key="indexin" v-for="(itemin, indexin)  in item.content">
                           <h6 class="t-text--xl t-text-lh--md t-text--ultra u-pad-t-lg" v-if="'title'===itemin.type.value" :class="[{'t-text--ultra--bold':itemin.bold==='true','u-color--brand-dark':itemin.color==='dark','u-color--white':itemin.color==='white','u-color--gray':itemin.color==='gray'},itemin.textalign]">
                               <app-scroll-object   :offset=".05"  :isParallax="!1" inline-template  :content="itemin" >
                                    <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                                </app-scroll-object >
                             </h6>
                           <div class="u-marg-t-md t-text--ultra" v-if=" 'default'===itemin.type.value" :class="[{'u-marg-t-md':indexin>0,'u-color--lightblue':itemin.color==='dark','u-color--white':itemin.color==='white'},itemin.textalign]" v-html="itemin.content"> </div>
                       </div>
                   </div>
                   <div class=" u-marg-b-lg@sm u-w1of2 u-w1of2@md  u-pad-l-0@lg u-fit-w@lg" :class="{'u-pad-l-w1of8':item.padLeft==='1'}">
                   </div>
                 </div>

    </section>

    <app-footer :globalContent="globalContent" :adminContent="adminContent"></app-footer>
</div>

</template>

<script>

import AppFooter from '../app-footer/index.vue'
import AppScrollObject from '../app-scroll-object/index.vue'
import AppSlicedText from '../app-sliced-text/index.vue'
import AppRiskTools from '../app-sliced-text/index.vue'

export default {
    props: {
      debug: {
          type: Boolean,
          default: !1
      },
        adminContent: {
            type: Object,
            default: function() {}
        },
        globalContent: {
            type: Object,
            default: function() {}
        },
        headerPageSize: {
            type: Array,
            default: function() {}
        }
    },
    components: {
        "app-footer": AppFooter,
        "app-scroll-object": AppScrollObject,
      
        "app-sliced-text": AppSlicedText,
        "app-risk-tools": AppRiskTools
    },
    computed: {
        content: function() {
            return this.adminContent.en.pages.aboutus
        },
        myStylesTransform2() {
            return {
                transform: 'translateX(' + this.headerPageSize[2] + 'px) translateY(' + this.headerPageSize[3] + 'px) scale(' + this.headerPageSize[4] + ')'

            }

        },
        myStylesWidthHeight() {
            return {
                width: this.headerPageSize[0] + "px",
                height: this.headerPageSize[1] + "px"

            }
        },
        myStylesWidthHeight11() {
            return {
                width: "1600px",
                height: "900px"

            }
        }
    },
    created: function() {
        this.eventHub.$on("resize", this.onResize)
    },
    destroyed: function() {
        this.eventHub.$off("resize", this.onResize)
    },
    mounted: function() {

        this.onResize(),
            this.eventHub.$emit("page:ready")
    },
    data: function() {
        return {

            

        }
    },
    methods: {
        onResize: function() {}
    }

}

</script>
